import { PRICE_PREVIEW, PRICE_PREVIEW_SUCCESS, PRICE_PREVIEW_ERROR, PRICE_PREVIEW_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const PricePreview = (state = initialState, action) => {
  switch (action.type) {
    case PRICE_PREVIEW:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case PRICE_PREVIEW_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case PRICE_PREVIEW_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case PRICE_PREVIEW_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default PricePreview;
